import { useCallback, useEffect, useState } from 'react';
import { Path, PathValue, useFormContext } from 'react-hook-form';

export const useUndoValue = <T, K extends Path<T>>(
    key: K,
): [PathValue<T, K> | undefined, (value: PathValue<T, K>) => void] => {
    const { getValues } = useFormContext<T>();
    const [memoValue, setMemoValue] = useState<PathValue<T, K>>();

    useEffect(() => {
        // getValues returns a reference so we need to copy the value
        setMemoValue({
            ...getValues(key),
        });
    }, [getValues, key]);

    const setValue = useCallback((value: PathValue<T, K>) => {
        setMemoValue(value);
    }, []);

    return [memoValue, setValue];
};
